"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.convertToOptions = exports.SIZE = exports.SEGMENT = exports.LINE_HEIGHT = exports.KIND_TEXT = exports.HEADING_LEVEL = exports.FONT_TYPE = exports.DISPLAY = exports.DECORATION = exports.COLOR = exports.BORDER = exports.ALIGN = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

var _Paragraph = _interopRequireDefault(require("./Paragraph"));

var _Heading = _interopRequireDefault(require("./Heading"));

var _Span = _interopRequireDefault(require("./Span"));

require("./textInfo.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const KIND_TEXT = {
  HEADING: 'heading',
  PARAGRAPH: 'paragraph',
  SPAN: 'span'
};
exports.KIND_TEXT = KIND_TEXT;
const DISPLAY = {
  INLINE: 'inline',
  BLOCK: 'block',
  DEFAULT: 'default'
};
exports.DISPLAY = DISPLAY;
const SEGMENT = {
  PARTICULARES: 'particulares',
  GP: 'gp',
  EMP: 'emp',
  EMPRESAS: 'empresas'
};
exports.SEGMENT = SEGMENT;
const BORDER = {
  NONE: 'none',
  ROUNDED: 'rounded'
};
exports.BORDER = BORDER;
const DECORATION = {
  LINE_THROUGH: 'linethrough',
  UNDERLINE: 'underline',
  NONE: 'none'
};
exports.DECORATION = DECORATION;
const COLOR = {
  TRANPARENT: 'transparent',
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  GREEN_1: 'green1',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  COOL_GREY: 'cool-grey',
  GREY_9: 'grey9',
  GREY_8: 'grey8',
  GREY_7: 'grey7',
  GREY_6: 'grey6',
  GREY_5: 'grey5',
  GREY_5B: 'grey5b',
  GREY_4: 'grey4',
  GREY_4A: 'grey4a',
  GREY_3: 'grey3',
  GREY_2: 'grey2',
  GREY_1: 'grey1',
  GREY_1A: 'grey1a',
  GREY_A: 'greya',
  GREY_0: 'grey0',
  ORANGE: 'orange',
  ORANGE_MEDIUM: 'orange-medium',
  ORANGE_LIGHT: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  EGG: 'egg',
  EGG_LIGHT: 'egg-light',
  EGG_DARK: 'egg-dark',
  BLUE: 'blue',
  BLUE_A: 'blue-a',
  BLUE_MEDIUM: 'blue-medium',
  BLUE_LIGHT: 'blue-light',
  BLUE_DARK: 'blue-dark',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  PINK: 'pink',
  PINK_LIGHT: 'pink-light',
  PINK_DARK: 'pink-dark',
  PIPPER: 'pipper',
  PIPPER_LIGHT: 'pipper-light',
  PIPPER_DARK: 'pipper-dark',
  RED: 'red',
  RED_1: 'red1',
  RED_LIGHT: 'red-light',
  RED_DARK: 'red-dark',
  CORAL: 'coral',
  CORAL_LIGHT: 'coral-light',
  CORAL_DARK: 'coral-dark',
  ORCHID_DARK: 'orchid-dark',
  TURQUOISE_LIGHT: 'turquoise-light',
  MOVISTAR_BLUE_DARK: 'movistar-blue-dark'
};
exports.COLOR = COLOR;
const ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  JUSTIFY: 'justify'
};
exports.ALIGN = ALIGN;
const HEADING_LEVEL = {
  H1: 1,
  H2: 2,
  H3: 3,
  H4: 4,
  H5: 5,
  H6: 6
};
/* KIND */

exports.HEADING_LEVEL = HEADING_LEVEL;
const SIZE = {
  TITLE1: 'title01',
  TITLE2: 'title02',
  TITLE3: 'title03',
  TITLE4: 'title04',
  TITLE45: 'title045',
  TITLE5: 'title05',
  TITLE6: 'title06',
  DISPLAY1: 'display01',
  DISPLAY2: 'display02',
  DISPLAY3: 'display03',
  CAPTION1: 'caption01',
  CAPTION2: 'caption02',
  CAPTION3: 'caption03'
};
exports.SIZE = SIZE;
const FONT_TYPE = {
  REGULAR: 'font-regular',
  LIGHT: 'font-light',
  THIN: 'font-thin',
  BOLD: 'font-bold',
  HAND: 'font-hand'
};
exports.FONT_TYPE = FONT_TYPE;
const LINE_HEIGHT = {
  NONE: 'none',
  REGULAR: 'regular'
};
exports.LINE_HEIGHT = LINE_HEIGHT;

const convertToOptions = optionsObject => {
  const keys = Object.keys(optionsObject);
  return keys.map(key => {
    return optionsObject[key];
  });
};

exports.convertToOptions = convertToOptions;

const TextInfo = props => {
  const myProps = (0, _gerenciatdUtils2.setUpPropsByDevice)(props);
  const {
    kind,
    text,
    cySelector
  } = myProps;
  let {
    segment
  } = myProps;
  let {
    lineHeight
  } = myProps;
  const existCurrentLineHeight = Object.values(LINE_HEIGHT).find(singleValue => singleValue === lineHeight);

  if (!existCurrentLineHeight) {
    lineHeight = LINE_HEIGHT.NONE;
  }

  switch (segment) {
    case 'empresas':
    case 'emp':
      segment = 'emp';
      break;

    case 'particulares':
    default:
      segment = 'gp';
      break;
  }

  if (!text) {
    (0, _gerenciatdUtils.errorLog)('[TextInfo]: text must be !== null');
    return null;
  }

  switch (kind) {
    case 'heading':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Heading.default, _objectSpread(_objectSpread({}, myProps), {}, {
        lineHeight: lineHeight,
        segment: segment,
        text: text,
        cySelector: cySelector
      }));

    case 'paragraph':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paragraph.default, _objectSpread(_objectSpread({}, myProps), {}, {
        lineHeight: lineHeight,
        segment: segment,
        text: text,
        cySelector: cySelector
      }));

    default:
    case 'span':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Span.default, _objectSpread(_objectSpread({}, myProps), {}, {
        lineHeight: lineHeight,
        segment: segment,
        text: text,
        cySelector: cySelector
      }));
  }
};

TextInfo.defaultProps = {
  size: SIZE.CAPTION2,
  color: COLOR.BLACK,
  fontType: FONT_TYPE.REGULAR,
  kind: KIND_TEXT.SPAN,
  align: ALIGN.LEFT,
  level: HEADING_LEVEL.H1,
  className: '',
  lineHeight: LINE_HEIGHT.NONE,
  display: DISPLAY.DEFAULT,
  backgroundColor: COLOR.TRANPARENT,
  segment: SEGMENT.GP,
  decoration: DECORATION.NONE,
  border: BORDER.NONE,
  cySelector: ''
};
TextInfo.propTypes = {
  /**
   * {
   *  "info": "Establece el texto que aparecerá dentro del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  text: _propTypes.default.string.isRequired,

  /**
   * {
   *  "info": "Define el color del componente según los tipos definidos en el array COLOR",
   *  "kind": "both",
   *  "beautifulName": "Color del texto"
   * }
   */
  color: _propTypes.default.oneOf(convertToOptions(COLOR)),

  /**
   * {
   *  "info": "Define el tamaño del texto del componente según los tipos definidos en el array SIZE",
   *  "kind": "both",
   *  "beautifulName": "Tamaño del texto"
   * }
   */
  size: _propTypes.default.oneOf(convertToOptions(SIZE)),

  /**
   * {
   *  "info": "Define la fuente del componente según los tipos definidos en el array FONT_TYPE",
   *  "kind": "both",
   *  "beautifulName": "Fuente del texto"
   * }
   */
  fontType: _propTypes.default.oneOf(convertToOptions(FONT_TYPE)),

  /**
   * {
   *  "info": "Define el tipo de texto del componente según los tipos definidos en el array KIND_TEXT",
   *  "kind": "both",
   *  "beautifulName": "Tipo del texto"
   * }
   */
  kind: _propTypes.default.oneOf(convertToOptions(KIND_TEXT)),

  /**
   * {
   *  "info": "Define la alineación de texto del componente según los tipos definidos en el array ALIGN",
   *  "kind": "both",
   *  "beautifulName": "Tipo del texto"
   * }
   */
  align: _propTypes.default.oneOf(convertToOptions(ALIGN)),

  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Define el line-height que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Tipo del texto"
   * }
   */
  lineHeight: _propTypes.default.oneOf(convertToOptions(LINE_HEIGHT)),

  /**
   * {
   *  "info": "Define el comportamiento del componente dentro del DOM según los tipos definidos en el array DISPLAY",
   *  "kind": "both",
   *  "beautifulName": "Tipo del elemento"
   * }
   */
  display: _propTypes.default.oneOf(convertToOptions(DISPLAY)),

  /**
   * {
   *  "info": "Define el color del background del componente según los tipos definidos en el array COLOR",
   *  "kind": "both",
   *  "beautifulName": "Color del texto"
   * }
   */
  backgroundColor: _propTypes.default.oneOf(convertToOptions(COLOR)),

  /**
   * {
   *  "info": "En caso de ser un encabezado, define el nivel según los tipos definidos en el array HEADING_LEVEL",
   *  "kind": "both",
   *  "beautifulName": "Nivel encabezado"
   * }
   */
  level: _propTypes.default.oneOf(convertToOptions(HEADING_LEVEL)),

  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes.default.oneOf(convertToOptions(SEGMENT)),

  /**
   * {
   *  "info": "Decorador para el text-info: 'subrayado', 'tachado'",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  decoration: _propTypes.default.oneOf(convertToOptions(DECORATION)),

  /**
   * {
   *  "info": "Establece tipo de borde, por defecto none",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  border: _propTypes.default.oneOf(convertToOptions(BORDER)),

  /**
   * {
   *  "info": "Establece selector único por pagina y componente para testing con cypress",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  cySelector: _propTypes.default.string
};
var _default = TextInfo;
exports.default = _default;

//# sourceMappingURL=index.js.map